import { gql, useQuery } from '@apollo/client';

import { useSearchableUsersCount_getSearchableUsersCountForMemberDirectory } from './graphql-types/useSearchableUsersCount_getSearchableUsersCountForMemberDirectory';

const QUERY = gql`
  query useSearchableUsersCount_getSearchableUsersCountForMemberDirectory {
    getSearchableUsersCountForMemberDirectory {
      result
    }
  }
`;

export const useSearchableUsersCount = (): {
  loading: boolean;
  searchableUsersCount: number;
} => {
  const { loading, data } =
    useQuery<useSearchableUsersCount_getSearchableUsersCountForMemberDirectory>(
      QUERY
    );

  return {
    loading,
    searchableUsersCount:
      data?.getSearchableUsersCountForMemberDirectory.result ?? 0,
  };
};
